<template>
    <div class="row">
        <div class="col-12 ">
            <b-breadcrumb class="mb-0">
                <b-breadcrumb-item v-for="(breadcrumb, index) in breadcrumbList"
                    :key="index"
                    @click="routeTo(breadcrumb.route)">
                    <p>{{breadcrumb.title}}</p>
                </b-breadcrumb-item>
            </b-breadcrumb>
        </div>
    </div>
</template>

<script>
export default {
    name: 'breadcrumb',
    data() {
        return {
        }
    },
    computed: {
        breadcrumbList() {
            return this.$route.meta.breadcrumb
        },
    },
    methods: {
        routeTo(route) {
            this.$router.push({ name: route, params: this.$router.params })
        },
    },
}
</script>
